// @flow
import * as React from 'react';
import {
  Form, TextArea, Select, Option,
} from 'informed';
import moment from 'moment';

import NumericText from '../../NumericText.jsx';
import ValidateText from '../../ValidateText.jsx';
import DatetimeText from '../../DatetimeText.jsx';
import { Label, PrimaryText, HeaderText } from '../../Typography.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';

import styles from '../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  editRow: ?Object,
  /*
    (rowId: string, row: Object) => {}
  */
  handleSaveRow: Function,
  /*
    (row: Object) => {}
  */
  handleSaveNewRow: Function,
  closeModal: Function,
}

class EditVitalSigns extends React.Component<Props> {
  formApi: {
    getState: Function,
    reset: Function,
  }

  componentDidUpdate() {
    this.formApi.reset();
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  handleSave = () => {
    const state = this.formApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.props.editRow) {
      this.props.handleSaveNewRow(state);
    } else if (Object.keys(state.touched).length) {
      this.props.handleSaveRow(this.props.editRow._id, state);
    }
    this.props.closeModal();
  }

  render() {
    const data = this.props.editRow || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <Form getApi={this.setFormApi} autoComplete='off'>
        <HeaderText>Vital Signs</HeaderText>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Temperature </PrimaryText></td>
              <td>
                <NumericText field='temperature' initialValue={data.temperature} size={7} />
                <Select field='temperatureUnit'>
                  <Option value='f'>°F</Option>
                  <Option value='c'>°C</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>
                <Select field='temperatureSite' initialValue={data.temperatureSite}>
                  <Option>--</Option>
                  <Option value='Oral'>Oral</Option>
                  <Option value='Tympanic'>Tympanic</Option>
                  <Option value='Axillary'>Axillary</Option>
                  <Option value='Rectal'>Rectal</Option>
                  <Option value='Other (see notes)'>Other (see notes)</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <td><PrimaryText>Respiration Rate </PrimaryText></td>
              <td><NumericText field='rr' initialValue={data.rr} size={7} /> breaths per min</td>
            </tr>
            <tr>
              <td><PrimaryText>Heart Rate </PrimaryText></td>
              <td><NumericText field='hr' initialValue={data.hr} size={7} /> bpm</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>
                <Select field='hrSite' initialValue={data.hrSite}>
                  <Option>--</Option>
                  <Option value='Apical'>Apical</Option>
                  <Option value='Left Radial'>Left Radial</Option>
                  <Option value='Right Radial'>Right Radial</Option>
                  <Option value='Other (see notes)'>Other (see notes)</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <td><PrimaryText>Blood Pressure </PrimaryText></td>
              <td>
                <ValidateText
                  placeholder='#/#'
                  field='bp'
                  initialValue={data.bp}
                  regex={/^(\d+\/\d+)?$/}
                  errorText={'Please enter valid BP, (e.g. 120/80)'}
                  size={7}
                />
              </td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>
                <Select field='bpSite' initialValue={data.bpSite}>
                  <Option>--</Option>
                  <Option value='Left Brachial'>Left Brachial</Option>
                  <Option value='Right Brachial'>Right Brachial</Option>
                  <Option value='Left Leg'>Left Leg</Option>
                  <Option value='Right Leg'>Right Leg</Option>
                  <Option value='Other (see notes)'>Other (see notes)</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <td><Label>Position</Label></td>
              <td>
                <Select field='bpPosition' initialValue={data.bpPosition}>
                  <Option>--</Option>
                  <Option value='Sitting'>Sitting</Option>
                  <Option value='Standing'>Standing</Option>
                  <Option value='Lying'>Lying</Option>
                </Select>
              </td>
            </tr>
            <tr>
              <td><PrimaryText>SpO2 </PrimaryText></td>
              <td><NumericText field='spo2' initialValue={data.spo2} size={8} /> %</td>
            </tr>
            <tr>
              <td><Label>Site</Label></td>
              <td>
                <Select field='spo2Site' initialValue={data.spo2Site}>
                  <Option>--</Option>
                  <Option value='Left Finger'>Left Finger</Option>
                  <Option value='Right Finger'>Right Finger</Option>
                  <Option value='Left Toe'>Left Toe</Option>
                  <Option value='Right Toe'>Right Toe</Option>
                  <Option value='Other (see notes)'>Other (see notes)</Option>
                </Select>
              </td>
            </tr>
          </tbody>
        </table>

        <div className={styles.notes}>
          <PrimaryText>Notes</PrimaryText><br />
          <TextArea field='notes' initialValue={data.notes} />
        </div>
        <table>
          <tbody>
            <tr>
              <td><PrimaryText>Exam Date </PrimaryText></td>
              <td><DatetimeText field='date' initialValue={data.date} /></td>
            </tr>
            <tr className={styles.editHistoryRow}>
              <td><strong>Edit History </strong></td>
              <td>{editHistory || '--'}</td>
            </tr>
          </tbody>
        </table>
        <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
        <Button onClick={this.props.closeModal}>Cancel</Button>
      </Form>
    );
  }
}

export default EditVitalSigns;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/vitals/EditVitalSigns.jsx